import { createContext } from 'react'

import type { DayObject } from 'types/graphql'

type PipelinesContextType = {
  workspaceId?: string
  pipelines?: DayObject[]
  opportunities?: DayObject[]
  stages?: DayObject[]
}

const PipelinesContext = createContext<PipelinesContextType | undefined>(
  undefined
)

export default PipelinesContext
